import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import {
  InboundOrderDto,
  OrderAttachmentDto,
} from 'src/app/domain/models/dto/inbound-order.dto';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { saveAs } from 'file-saver';
import { AdminOrderEditModal } from '../order-edit-modal/admin-order-edit-modal.component';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { NotifierService } from 'angular-notifier';
import { OrderReviewReprovedModalComponent } from '../order-review-reproved-modal/order-review-reproved-modal.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrderReviewModalComponent } from '../order-review-modal/order-review-modal.component';
import { TreasuryInfoComponent } from '../treasury-info/treasury-info.component';
import { ExchangeInfoComponent } from '../exchange-info/exchange-info.component';
import { PaymentConfirmComponent } from '../payment-confirm/payment-confirm.component';
import { SettlementDocumentsComponent } from '../../../orders-history/modals/settlement-documents/settlement-documents.component';
import { AttachProofOperationComponent } from '../attach-proof-operation/attach-proof-operation.component';
import { PaymentConfirmApprovedComponent } from '../payment-confirm-approved/payment-confirm-approved.component';
import { ExecutionOrderComponent } from '../execution-order/execution-order.component';

@Component({
  selector: 'app-new-order-modal',
  templateUrl: './admin-order-detail-modal.component.html',
  styleUrls: ['./admin-order-detail-modal.component.scss'],
})
export class AdminOrderDetailModalComponent implements OnInit, OnDestroy {
  private readonly notifier: NotifierService;
  boobleModalData: any;
  rType: string = '1';
  moedas = Moedas;
  currency: any;
  public loading: boolean = true;
  private destroy$ = new Subject<void>();

  iof: number;
  ir: number;
  commercial: number;

  constructor(
    private router: Router,
    private modalService: BoobleModalService,
    notifierService: NotifierService,
    private ordersService: OrdersService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    if (typeof this.boobleModalData === 'number') {
      this.loading = true;
      this.ordersService
        .getOrderById(this.boobleModalData, "true")
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (result) => {
            this.boobleModalData = result.data;
            this.rType = result.data.remmitanceType === 'INBOUND' ? '0' : '1';
            this.initializeComponent();
            this.loading = false;
          },
          error: (err) => {
            this.loading = false;
          },
        });
    } else {
      this.initializeComponent();
      this.loading = false;
    }
  }

  initializeComponent() {
    // this.rType = this.router.url.includes('0') ? '0' : '1';
    this.currency = this.moedas.find(
      (moeda) => moeda.id === this.boobleModalData?.currency?.id
    );

    if (this.boobleModalData?.quotations?.length > 0) {
      if (this.boobleModalData.remmitanceType === 'OUTBOUND') {
        this.ir = this.boobleModalData.quotations[0].irOutbound;
        this.iof = this.boobleModalData.quotations[0].iofOutbound;
        this.commercial = Number(
          (
            this.boobleModalData.quotations[0].rate +
            this.boobleModalData.quotations[0].rate *
            this.boobleModalData.quotations[0].spread
          ).toPrecision(5)
        );
      } else if (this.boobleModalData.remmitanceType === 'INBOUND') {
        this.ir = this.boobleModalData.quotations[0].irInbound;
        this.iof = this.boobleModalData.quotations[0].iofInboud;
        this.commercial = Number(
          (
            this.boobleModalData.quotations[0].rate -
            this.boobleModalData.quotations[0].rate *
            this.boobleModalData.quotations[0].spread
          ).toPrecision(5)
        );
      }
    }
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

  increasePercentage(value: number, percentage: number) {
    return value + value * percentage;
  }

  getIr(rate: number, spread: number, taxIr: number, ptax: number) {
    const residualIr =
      ((this.increasePercentage(rate, spread) < ptax
        ? ptax
        : this.increasePercentage(rate, spread)) *
        this.boobleModalData.amount) /
      (1 - taxIr);
    return residualIr * taxIr;
  }

  editOrder() {
    this.modalService.present(AdminOrderEditModal, this.boobleModalData);
  }

  downloadAttachment(orderAttachment: OrderAttachmentDto) {
    this.ordersService.downloadOrderAttachment(orderAttachment.id).subscribe({
      next: (data: any) => saveAs(data, orderAttachment.fileName),
    });
  }

  openAttachProofOperationModal(orderId: number) {
    this.modalService.present(AttachProofOperationComponent, orderId);
  }

  openSettlementDocumentsComponentModal(orderId: number) {
    this.modalService.present(SettlementDocumentsComponent, orderId);
  }

  openPaymentConfirmModal(order: InboundOrderDto) {
    this.modalService.present(PaymentConfirmComponent, order);
  }

  openOrderReviewModal(order: InboundOrderDto) {
    this.modalService.present(OrderReviewModalComponent, order);
  }

  openTreasuryInfoModal(order: InboundOrderDto) {
    this.modalService.present(TreasuryInfoComponent, order);
  }

  openExchangeInfoModal(order: InboundOrderDto) {
    this.modalService.present(ExchangeInfoComponent, order);
  }

  downloadAttachmentByName(fileName: string) {
    this.ordersService.downloadOrderAttachmentByName(fileName).subscribe({
      next: (data: any) => {
        saveAs(data, fileName);
        this.notifier.notify(
          'success',
          'Download do arquivo realizado com sucesso.'
        );
      },
      error: () => {
        this.notifier.notify('error', 'Erro ao efetuar o download do arquivo.');
      },
    });
  }

  attachmentFileName(fileName: string) {
    return fileName.substring(fileName.lastIndexOf('-') + 1, fileName.length);
  }

  cancelOrder(order: any) {
    this.modalService.present(OrderReviewReprovedModalComponent, {
      type: 'cancel',
      order: order,
    });
  }

  cancelQuotation() {
    this.loading = true;

    this.ordersService.cancelQuotation(this.boobleModalData?.id).subscribe({
      next: () => {
        this.loading = false;
        this.closeModal();
        this.notifier.notify('success', 'Cotação cancelada com sucesso.');
        this.ordersService.updateOrderView();
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  /*   approvePaymentConfirm() {
    this.loading = true;

    this.ordersService.approvePayment(this.boobleModalData?.id).subscribe({
      next: () => {
        this.loading = false;
        this.closeModal();
        this.notifier.notify('success', 'Pagamento confirmado com sucesso.');
        this.ordersService.updateOrderView();
      },
      error: () => {
        this.loading = false;
      },
    });
  } */

  openPaymentConfirmApprovedModal(order: InboundOrderDto) {
    this.modalService.present(PaymentConfirmApprovedComponent, order);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openExecutionOrderModal(order: InboundOrderDto) {
    this.modalService.present(ExecutionOrderComponent, order);
  }
}
